'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EXPORT_BOARD_FETCH = exports.EXPORT_BOARD_FETCH = 'EXPORT_BOARD_FETCH';
var EXPORT_BOARD_FAIL = exports.EXPORT_BOARD_FAIL = 'EXPORT_BOARD_FAIL';
var EXPORT_BOARD_SUCCESS = exports.EXPORT_BOARD_SUCCESS = 'EXPORT_BOARD_SUCCESS';

var EXPORT_BOARD_STATES = exports.EXPORT_BOARD_STATES = {
    FETCHING: 'FETCHING',
    FAILED: 'FAILED'
};

var EXPORT_ROOT_ELEMENT_ID = exports.EXPORT_ROOT_ELEMENT_ID = 'export-root';


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/export/exportConstants.js
// module id = 317
// module chunks = 0